<template>
  <div
    v-if="
      $route.name === 'Cliente' && $route.matched.at(-1)?.name === 'Cliente'
    "
  >
    <page-header :title="titleCase(activeKey)" :breadcrumRoutes="routes">
      <template #buttons>
        <a-button v-if="show_holding" @click="createHolding" type="primary">
          Crear holding
        </a-button>
        <a-button
          v-if="show_subholding"
          @click="createSubHolding"
          type="primary"
        >
          Crear Subholding
        </a-button>
        <a-button v-if="show_empresas" @click="createEmpresa" type="primary">
          Crear empresa
        </a-button>
      </template>
    </page-header>

    <a-card>
      <a-tabs
        :style="{ zIndex: 0 }"
        v-model:activeKey="activeKey"
        @tabClick="tabClick"
      >
        <a-tab-pane tab="Holdings" key="Holdings" />
        <a-tab-pane tab="Subholdings" key="Subholdings" />
        <a-tab-pane tab="Empresas" key="Empresas" />
      </a-tabs>

      <keep-alive>
        <component :is="currentTabComponent" ref="currentTabRef" />
      </keep-alive>
    </a-card>
  </div>
  <div v-else>
    <router-view :key="$route.path"></router-view>
  </div>
</template>

<script>
import { computed, onBeforeMount, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import PageHeader from '@/components/page-header.vue';
import Holdings from './client_components/holdings.vue';
import Subholdings from './client_components/subholdings.vue';
import Empresas from './client_components/companies.vue';
import { GET_LOGGED_USER, SAVE_CLIENT_CURRENT_TAB } from '@/store/types';

export default {
  name: 'ClientDashboard',
  components: {
    'page-header': PageHeader
  },
  setup() {
    // * Vuex
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const user_role = computed(() => store.getters[GET_LOGGED_USER]?.roleName);

    // * Tabs
    const tabConfig = {
      Holdings: { component: Holdings, hash: '#holdings' },
      Subholdings: { component: Subholdings, hash: '#subholdings' },
      Empresas: { component: Empresas, hash: '#empresas' }
    };
    const tabParams = ref({
      Holdings: {},
      Subholdings: {},
      Empresas: {}
    });

    const activeKey = ref('Holdings');

    const currentTabComponent = computed(
      () => tabConfig[activeKey.value]?.component || Holdings
    );
    const currentTabRef = ref(null);

    const resolveActiveKeyFromHash = (hash) => {
      const entry = Object.entries(tabConfig).find(
        ([, value]) => value.hash === hash
      );
      return entry?.[0] || 'Empresas';
    };

    onBeforeMount(() => {
      const isClientListRoute =
        route.name === 'Cliente' && route.matched.at(-1)?.name === 'Cliente';
      if (!isClientListRoute) {
        return;
      }
      if (!route.hash) {
        router.replace({
          name: 'Cliente',
          query: route.query,
          hash: '#empresas'
        });
        activeKey.value = 'Empresas';
        return;
      }

      activeKey.value = resolveActiveKeyFromHash(route.hash);

      tabParams.value[activeKey.value] = { ...route.query };
    });

    const tabClick = async (targetTab) => {
      tabParams.value[activeKey.value] = { ...route.query };

      const hash = tabConfig[targetTab]?.hash || '';

      await router.replace({
        name: 'Cliente',
        query: tabParams.value[targetTab],
        hash
      });
    };

    // * Poner el titulo del tab en mayuscula
    const titleCase = (string) => {
      return string[0].toUpperCase() + string.slice(1).toLowerCase();
    };

    // * Page header
    const show_holding = computed(() => {
      return activeKey.value === 'Holdings' && user_role.value === 'superadmin';
    });

    const show_subholding = computed(() => {
      return (
        activeKey.value === 'Subholdings' && user_role.value === 'superadmin'
      );
    });

    const show_empresas = computed(() => {
      return activeKey.value === 'Empresas' && user_role.value === 'superadmin';
    });

    // * Holding

    const createHolding = () => {
      currentTabRef.value?.holdingCreation?.();
    };

    const createSubHolding = () => {
      currentTabRef.value?.subHoldingCreation?.();
    };

    const createEmpresa = () => {
      currentTabRef.value?.companyCreation?.();
    };

    // * Cambio del breadcrums en caso de que se cambie el tab
    const routes = computed(() => [
      {
        path: '/clientes',
        breadcrumbName: 'Cliente'
      },
      {
        breadcrumbName: activeKey.value
      }
    ]);

    watch(activeKey, (value) => {
      store.dispatch(SAVE_CLIENT_CURRENT_TAB, value);
    });

    watch(
      () => route.hash,
      (hash) => {
        if (!hash) return;
        activeKey.value = resolveActiveKeyFromHash(hash);
      }
    );

    return {
      activeKey,
      currentTabComponent,
      currentTabRef,
      titleCase,
      routes,
      show_holding,
      show_subholding,
      show_empresas,
      user_role,
      createHolding,
      createSubHolding,
      createEmpresa,
      tabClick
    };
  }
};
</script>
